import { createApp } from 'vue';
import App from './App.vue';
import './assets/main.scss';
// AB#22137 — phone-only layout fixes for desktop-first pages.
import './assets/phone.scss';
// AB#22137 phase 5 — tablet (768-1024px) touch sizes.
import './assets/tablet.scss';
import router from './router/index';
import imgFallback from './directives/v-img-fallback';
import { VueQueryPlugin } from '@tanstack/vue-query';
//@ts-ignore
import vSelect from 'vue-select';
import * as LucideIcons from 'lucide-vue-next';
import { setPageTitle } from './composables';
import { getCsrfToken } from '@/utils/csrf';
import { initTheme } from './composables/useTheme';

// AB#21595 — apply the stored light/dark theme before the app mounts, so the
// first paint is already correct and there is no flash of the wrong theme.
initTheme();

async function mountApp() {
  if (import.meta.env.MODE === 'local-qa') {
    const { installLocalQa } = await import('../tools/local-qa/adapter');
    installLocalQa();
  }
  const app = createApp(App);

  app.use(router).use(VueQueryPlugin);
  app.directive('img-fallback', imgFallback);
  app.mount('#app');

  if (import.meta.env.MODE !== 'local-qa') void getCsrfToken().catch(() => {});

  Object.keys(LucideIcons.icons).forEach((name) => {
    app.component(name, LucideIcons.icons[name].component);
  });
  app.component('v-select', vSelect);
}
void mountApp();
